<script>
import contact from "@/utils/contact";
import LoaderMixin from "@/mixins/Loader.mixin";
import CompanyModel from "@/models/CompanyModel";
import ModelMixin from "@/mixins/Model.mixin";
import { mapGetters } from 'vuex';
import { unique } from "@/utils/"

const COMPANY = CompanyModel.ModelName

export default {
  mixins: [
    LoaderMixin([COMPANY]),
    ModelMixin({
      contact,
      models: [CompanyModel]
    })
  ],
  model:{
    prop: "value",
    event: "change"
  },
  props: {
    params: {
      type: Object,
      default: ()=>{}
    },
    disabled: {
      type: Boolean
    },
    transfer: Boolean,
    canNew: Boolean,
    disable: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    hasPagination: {
      type: Boolean,
      default: true
    },
    remote: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    itemCreateFun: {
      type: Function,
      default: ()=>Promise.resolve(true)
    },
    options: {
      type: Array,
      default: ()=>[]
    },
    value: {
      type: Array,
      default: ()=>[]
    },
    placeholder: {
      type: String,
      default: "公司"
    },
    sourceType: {
      type:String,
      default: 'listedCompany' // company, listedCompany
    },
  },
  watch:{
    value(val){
      this.sources.value = val
    },
    params(val){
      this.conditions = val
    }
  },
  render(h){
    const {
      $attrs,
      $props,
    } = this
    return h('RichSearchInput',{
      attrs: $attrs,
      props: {
        ...$props,
        remote: true,
        options: this.items,
        remoteOptions: this.remoteOptions,
        remoteValue: this.remoteValue,
      },
      on: {
        change: this.onChanged,
      },
    },[])
  },
  data(){
    return {
      loading: false,
      input: '',
      pagination: { page:1, total:0, limit:10, offset:0 },
      items: [],
      sources: {
        value: []
      },
      conditions: {}
    }
  },
  methods: {
    async remoteOptions({ currentPage, limit, searchTxt }){
      const list = this[this.sourceType].filter(i=>i.title.indexOf(searchTxt)>-1)
      const offset = !!searchTxt ? 0 : currentPage * limit - limit
      return {
        items: list.slice(offset, offset+limit),
        total: list.length,
        currentPage: currentPage,
      }
    },
    remoteValue({items,checkIds}){
      return Promise.resolve(this[this.sourceType].filter(item=>checkIds.includes(item.id)))
    },
    onChanged(value){
      this.$emit("change", value)
    },
  },
  computed:{
    ...mapGetters(['listedCompany','company'])
  }
}
</script>
